import { Status } from '../model/status';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Diaper, DiaperBrand } from '../model/diaper';
import { HttpHelperService } from './httphelper.service';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UserSessionService } from './user-session.service';

const API_URL = environment.apiUrl;

@Injectable({
	providedIn: 'root'
})
export class DiaperService {
	constructor(
		private httpClient: HttpClient,
		private userSessionService: UserSessionService,
		private httpHelperService: HttpHelperService) {
	}

	getDiaperList(status: Status) {
		return this.httpClient.get<Diaper[]>(API_URL + 'diaper/list?status=' + status, this.httpHelperService.getHttpOptions());
	}

	getDiaper(id: string) {
		return this.httpClient.get<Diaper>(API_URL + 'diaper/' + id, this.httpHelperService.getHttpOptions());
	}

	importDiaperList(formData: FormData) {
		console.log(formData);
		return this.httpClient.post<any>(`${API_URL}diaper`, formData,
			{
				reportProgress: true,
				observe: 'events',
				withCredentials: true
			}).pipe(
				map(event => event),
				catchError(this.handleError)
			);
	}

	getDiaperBrands() {
		return this.httpClient.get<DiaperBrand[]>(`${API_URL}diaper/brands`, this.httpHelperService.getHttpOptions());
	}

	getAccessibleDiaperBrands() {
		return this.httpClient.get<string[]>(`${API_URL}diaperbrand/${this.userSessionService.getSelectedCarehome()}`, this.httpHelperService.getHttpOptions());
	}

	updateAccessibleDiaperBrands(diaperBrands: DiaperBrand[]) {
		return this.httpClient.post<boolean>(`${API_URL}diaperbrand/${this.userSessionService.getSelectedCarehome()}`, diaperBrands, this.httpHelperService.getHttpOptions());
	}

	private handleError(error: HttpErrorResponse) {
		return throwError(error.error);
	}
}
